import request from '@/utils/request'

// 查询报告上传公示列表
export function listUp(query) {
  return request({
    url: '/system/up/list',
    method: 'get',
    params: query
  })
}

// 查询报告上传公示详细
export function getUp(id) {
  return request({
    url: '/system/up/' + id,
    method: 'get'
  })
}

// 新增报告上传公示
export function addUp(data) {
  return request({
    url: '/system/up',
    method: 'post',
    data: data
  })
}

// 修改报告上传公示
export function updateUp(data) {
  return request({
    url: '/system/up',
    method: 'put',
    data: data
  })
}

// 删除报告上传公示
export function delUp(id) {
  return request({
    url: '/system/up/' + id,
    method: 'delete'
  })
}
